module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start06-0b4f1ef98c2952d89dda604673be60e8.gif";